import type { AddPreflightMarketInput } from "@nexus/contracts";
import type { TenantListItem } from "@/features/identity-hub/api/identity-hub.api";
import { BRAND_COLORS } from "@/features/identity-hub/lib/brand-colors";
import {
  DEFAULT_TENANT_PRODUCT_LINE,
  resolveTenantProductLine,
  type TenantProductLine,
} from "@/features/identity-hub/lib/org-settings-dirty";

export interface NewOrgCopyFromFormState {
  type: "ORGANIZATION" | "API";
  productLine: TenantProductLine;
  industryIndices: string[];
  preflightMarketRefs: AddPreflightMarketInput[];
  defaultIndustry: string | null;
  defaultBrand: string;
  color: string;
}

export function resolveCopyFromBrandColor(sourceColor: string | null | undefined): string {
  const trimmed = sourceColor?.trim();
  if (!trimmed) return BRAND_COLORS[0].value;
  const paletteMatch = BRAND_COLORS.find(
    (c) => c.value.toLowerCase() === trimmed.toLowerCase(),
  );
  if (paletteMatch) return paletteMatch.value;
  if (/^#[0-9a-fA-F]{6}$/.test(trimmed)) return trimmed;
  return BRAND_COLORS[0].value;
}

export function buildNewOrgStateFromCopySource(
  source: TenantListItem,
  marketRefs: AddPreflightMarketInput[],
): NewOrgCopyFromFormState {
  const industryIndices = [...(source.industryIndices ?? [])];
  const defaultIndustryRaw = source.defaultIndustry;
  const defaultIndustry =
    defaultIndustryRaw && industryIndices.includes(defaultIndustryRaw)
      ? defaultIndustryRaw
      : industryIndices.length === 1
        ? industryIndices[0]!
        : null;

  const type: "ORGANIZATION" | "API" =
    source.type === "API" ? "API" : "ORGANIZATION";

  return {
    type,
    productLine: resolveTenantProductLine(source.productLine ?? DEFAULT_TENANT_PRODUCT_LINE),
    industryIndices,
    preflightMarketRefs: marketRefs,
    defaultIndustry,
    defaultBrand: source.defaultBrand?.trim() ?? "",
    color: resolveCopyFromBrandColor(source.brandColor),
  };
}
